import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Import} from '../../dto/import';
import {Router} from '@angular/router';

@Component({
  selector: 'app-file-import-dialog',
  templateUrl: './file-import-dialog.component.html',
  styleUrls: ['./file-import-dialog.component.css']
})
export class FileImportDialogComponent implements OnInit {

  public title: string;
  public text: string;

  public import: Import;
  public link: string;

  constructor(
    public dialogRef: MatDialogRef<FileImportDialogComponent>,
    private router: Router,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    if (this.data != null) {
      this.import = this.data.import;
      this.link = this.data.link;

      if (this.import.invalidRowCount > 0) {
        this.title = `Upload failed`;
        this.text = `File was uploaded. Some errors occured during import.` +
        ` Invalid rows: ${this.import.invalidRowCount}.` +
        ` Total rows: ${this.import.totalRowCount}`;
      } else {
        this.title = `Upload succeed`;
        this.text = `File was uploaded succesfully. Imported rows: ${this.import.totalRowCount}`;
      }
    }
  }

  onActionClick(): void {
    this.dialogRef.close('action');
    // this.router.navigate([this.link]);
  }

  onOkClick(): void {
    this.dialogRef.close('ok');
  }
}
